import Rental from '../views/rentals/Rental'

export default [
  {
    name: 'rentals',
    path: '/locations/:id',
    component: Rental
  }
]
